import styled from '@emotion/styled';

/* stylelint-disable */
export const MenuSectionsTitle = styled('span', { label: 'MenuSectionsTitle' })`
    display: block;
    padding: var(--spacing-2, 8px) var(--spacing-3, 12px);
`;

export const MenuSectionsLinksContainer = styled('nav', { label: 'MenuSectionsLinksContainer' })`
    padding: var(--spacing-2, 8px) var(--spacing-3, 12px);
`;
